import { OperationWithLabel } from '../../types/sharedTypeImpl.ts';
import { reportError } from '../../utils/errorReporting.ts';
import { trpcClient } from '../../utils/trpc/trpc.ts';


export async function revertOperation(
    operation: OperationWithLabel,
    onSuccess: () => void
) {
    const confirmation = window.confirm(
        `Are you sure you want to revert this operation?` +
        `\nPart number: ${operation.partDisplayName}` +
        `\n${operation.details.join(' > ')}`
    );
    if (!confirmation) return;

    const updatedOperation = { ...operation };
    if (updatedOperation.scrapCloseForm) {
        delete updatedOperation.scrapCloseForm;
    } else if (updatedOperation.scrapReview) {
        delete updatedOperation.scrapReview;
    } else {
        throw new Error('Operation does not have scrap review or close form to revert.');
    }
    delete updatedOperation.scrapHandledAt;

    if (!operation.potentialScraps) {
        throw new Error('Attempting to revert operation without potential scraps.');
    }

    const reobtainLabel = !operation.scrapLabel;

    try {
        await trpcClient.operations.update.mutate({
            operation: updatedOperation,
            createScrapLabel: reobtainLabel,
        });
        onSuccess();
    } catch (error) {
        alert('Failed to revert operation');
        reportError(error);
    }
}
